import { useAtomValue, useSetAtom } from 'jotai'

import { DateRangePickerInput } from '@sequencehq/core-components'
import { formatISODate } from '@sequencehq/utils'
import {
  clientInvoiceAtom,
  invoiceBillingPeriodDatesAtom,
  isSavePendingAtom
} from 'Invoices/atoms/invoiceEditing.atom'

export const CurrentInvoiceBillingPeriodPicker = ({
  inputWidth = '100%',
  'data-testid': dataTestId,
  openOnMount = false
}: {
  inputWidth?: string
  'data-testid'?: string
  openOnMount?: boolean
}) => {
  const partialUpdateInvoice = useSetAtom(clientInvoiceAtom)
  const billingPeriodDates = useAtomValue(invoiceBillingPeriodDatesAtom)
  const isSavePending = useAtomValue(isSavePendingAtom)

  return (
    <DateRangePickerInput
      withOptions={false}
      value={
        billingPeriodDates
          ? [billingPeriodDates.start, billingPeriodDates.endInclusive]
          : undefined
      }
      onChange={([start, end]) => {
        partialUpdateInvoice({
          billingPeriod: {
            start: formatISODate(start),
            endInclusive: formatISODate(end)
          }
        })
      }}
      popoverPlacement="end"
      inputWidth={inputWidth}
      iconPlacement="trailing"
      isDisabled={isSavePending}
      data-testid={dataTestId}
      openOnMount={openOnMount}
    />
  )
}
